import { InputText } from "primereact/inputtext";
import { classNames } from "primereact/utils";
import { useTranslation } from "react-i18next";
import { Controller, useForm} from 'react-hook-form';
import { Button } from "primereact/button";
import { useEffect, useRef, useState } from "react";
import { DataTable } from "primereact/datatable";
import { Column } from "primereact/column";
import { Panel } from "primereact/panel";
import React from "react";
import { Dropdown } from "primereact/dropdown";
import getMotorCreditoFormula from "../../service/getMotorCreditoFormula";
import getOperadoresRegraCredito from "../../service/getOperadoresRegraCredito";
import getAcoesRegraCredito from "../../service/getAcoesRegraCredito";
import getResultadoMotorCredito from "../../service/getResultadoMotorCredito";
import { InputNumber } from "primereact/inputnumber";
import { useGlobalState } from "../../components/globalState/GlobalStateProvider";
import findClient from "../../service/findClient";
import { SortOrder } from "primereact/api";
 
export default function MotorCreditoCadastrar({msgs, motorCredito, onClose, onSave}:{msgs:any, motorCredito:any, onClose: () => void, onSave: (motorCredito:any) => void}) {
  const { t } = useTranslation();
  const [showRegra, setShowRegra] = useState<boolean>(false);
  const [regras, setRegras] = useState<any[]>(motorCredito?.regras);
  const [operadores, setOperadores] = useState<any[]>();
  const [acoes, setAcoes] = useState<any[]>();
  const [formulas, setFormulas] = useState<any[]>();
  const [descricao, setDescricao] = useState<string>();
  const [valor, setValor] = useState<string>();
  const [valorSecundario, setValorSecundario] = useState<string>();
  const [pontuacao, setPontuacao] = useState<number|null>();
  const [selectedFormula, setSelectedFormula] = useState<any>();
  const [selectedOperador, setSelectedOperador] = useState<any>();
  const [selectedAcao, setSelectedAcao] = useState<any>();
  const [regraEdit, setRegraEdit] = useState<any>();
  const [resultados, setResultados] = useState<any[]>([]);
  const {state} = useGlobalState();
  const [clients, setClients] = useState<any>([]);
  const [selectedClient, setSelectedClient] = useState<any>(null);
  const defaultValues = {
    descricao: '',
    resultadoMotorCredito: null
  };
  defaultValues.descricao = motorCredito.descricao ? motorCredito.descricao.toString() : ''
 
 
  
  const {
      control,
      formState: { errors},
      handleSubmit,
      setValue
  } = useForm({ defaultValues });
 
  const onSubmit = (data:any) => {
      data.descricao && save(data);
  };
 
  const salvarRegra = () => {
    if(valor && descricao && selectedFormula && selectedOperador && selectedAcao){
      
      if(selectedAcao === 'PONTUAR' && !pontuacao){
        msgs.current?.clear();
        msgs.current?.show([
            { sticky: false, life: 10000, severity: 'error', summary: 'Erro', detail: 'Pontuação obrigatórios', closable: false }
           
        ]);
        window.scrollTo(0, 0);
      }else{
        const lista = []
      regras?.forEach((p) => lista.push(p))
      const results = regras?.filter((p) => p.descricao === descricao)
      if(results && results.length !== 0 && (!regraEdit || regraEdit.formula.descricao !== selectedFormula.descricao)){
        msgs.current?.clear();
        msgs.current?.show([
            { sticky: false, life: 10000, severity: 'error', summary: 'Erro', detail: 'Fórmula já existe', closable: false }
           
        ]);
        window.scrollTo(0, 0);
      }
      else{
        if(!regraEdit){
          lista.push({valor:valor, valorSecundario:valorSecundario, operador:selectedOperador, descricao: descricao, formula: selectedFormula, acao: selectedAcao, pontuacao: pontuacao})
        }
        else{
          regraEdit.formula = selectedFormula;
          regraEdit.operador = selectedOperador;
          regraEdit.descricao = descricao;
          regraEdit.valor = valor;
          regraEdit.valorSecundario = valorSecundario;
          regraEdit.acao = selectedAcao;
          regraEdit.pontuacao = pontuacao;
        }
        setRegras(lista)
        setSelectedFormula(null)
        setSelectedOperador(null)
        setValor('')
        setValorSecundario('')
        setDescricao('')
        setShowRegra(false)
      }
 
      }
      
    }
    else{
      msgs.current?.clear();
        msgs.current?.show([
            { sticky: false, life: 10000, severity: 'error', summary: 'Erro', detail: 'Ação, Fórmula, Operador e valor são obrigatórios', closable: false }
           
        ]);
        window.scrollTo(0, 0);
    }
  }
 
  const save = (data:any) => {
    const formula = {
      id: motorCredito.id? motorCredito.id : undefined,
      descricao:data.descricao,
      idCliente: selectedClient ? selectedClient.code : null,
      resultadoMotorCredito: data.resultadoMotorCredito.id,
      regras:regras
    }
    window.scrollTo(0, 0);
    onSave(formula);
  }
  
  const getFormErrorMessage = (name:string) => {
    type ObjectKey = keyof typeof errors;
    const error = errors[Object.keys(errors).find(k => k === name) as ObjectKey]
    return error ? <small className="p-error">{error.message}</small> : <small className="p-error">&nbsp;</small>;
  };
 
  const editRegraBodyTemplate = (item:any) => {
    return <>
      <Button icon="pi pi-pencil" type="button" onClick={(e) => {setValor(item.valor); setValorSecundario(item.valorSecundario);  setPontuacao(item.pontuacao); setDescricao(item.descricao); setSelectedFormula(formulas?.filter((s:any) => s.descricao === item.formula.descricao)[0]); setSelectedAcao(item.acao); setSelectedOperador(item.operador); setRegraEdit(regras.filter((s: any) => s.formula.descricao === item.formula.descricao)[0] ); setShowRegra(true);}} style={{background:'transparent', color:'gray', border: 'none'}} />
      <Button icon="pi pi-trash" type="button" onClick={() => {setRegras(regras?.filter((s) => s.descricao !== item.descricao))}} style={{background:'transparent', color:'gray', border: 'none'}} />
    </>
  };
 
  const paginatorRight = (
    <React.Fragment>
        {!showRegra && (
          <div style={{display:"flex", justifyContent:"flex-end", paddingTop:"1rem"}} className=" flex">
            <Button form='form-permission' style={{marginRight:"1rem", backgroundColor:'#183462'}} label="Adicionar Regra" onClick={()=>setShowRegra(true)} />
          </div>
          )
        }
          {showRegra && (
            <Panel>
               
                <div className="grid">
                  <div className="col p-fluid flex flex-wrap">
                    <label htmlFor="servico" className="font-bold block mb-2 required">{t('descricao')} </label>
                    <InputText value={descricao} onChange={(e) => setDescricao(e.target.value)} />
                  </div>
                  <div className="col p-fluid flex flex-wrap">
                    <label htmlFor="servico" className="font-bold block mb-2 required">{t('formula')} </label>
                    <Dropdown style={{width: '50%'}} value={selectedFormula} onChange={(e) => setSelectedFormula(e.value)} options={formulas} optionLabel="descricao" placeholder="Selecione Fórmula" 
                        filter className=" md:w-14rem" />   
                  </div>
                </div>
                <div className="grid">
                  <div className="col p-fluid flex flex-wrap">
                    <label htmlFor="operador" className="font-bold block mb-2 required">{t('operador')} </label>
                    <Dropdown style={{width: '50%'}} value={selectedOperador} onChange={(e) => setSelectedOperador(e.value)} options={operadores} optionLabel="label" placeholder="Selecione Operador" 
                        filter className=" md:w-14rem" />  
                  </div>
                  <div className="col p-fluid flex flex-wrap">
                    <div>
                      <label htmlFor="valor" className="font-bold block mb-2 required">{t('valor')} </label>
                      <InputText value={valor} onChange={(e) => setValor(e.target.value)} />
                      {selectedOperador === 'ENTRE' && (<>
                        <label htmlFor="valorSecundario" className="font-bold block mb-2 required">{t('valor')} </label>
                        <InputText value={valorSecundario} onChange={(e) => setValorSecundario(e.target.value)} />
                       </>)} 
                    </div>
                  </div>
                </div>
                <div className="grid">
                  <div className="col p-fluid flex flex-wrap">
                    <label htmlFor="operador" className="font-bold block mb-2 required">{t('acao')} </label>
                    <Dropdown style={{width: '50%'}} value={selectedAcao} onChange={(e) => setSelectedAcao(e.value)} options={acoes} optionLabel="label" placeholder="Selecione Ação" 
                        filter className=" md:w-14rem" />  
                  </div>
                  <div className="col p-fluid flex flex-wrap">
                    <label htmlFor="valor" className="font-bold block mb-2">{t('pontuacao')} </label>
                    <InputNumber disabled = {!selectedAcao || selectedAcao === 'REPROVAR'} value={pontuacao} onChange={(e) => setPontuacao(e.value)} />
                    
                  </div>
                </div>
                <div style={{display:"flex", justifyContent:"flex-end", paddingTop:"1rem"}} className=" flex">
                  <Button form='form-permission' style={{marginRight:"1rem", backgroundColor:'#183462'}} label="Salvar Regra" onClick={()=>salvarRegra()} />
                  <Button label="Fechar" icon="pi pi-times" style={{color:'#183462'}} onClick={() => setShowRegra(false)} className="p-button-text" />
                </div>
             
            
            </Panel>
          )}
          
    </React.Fragment>
    );
 
    useEffect(() => {
      if(motorCredito.id){
 
      }
      getMotorCreditoFormula().then( (data) => setFormulas(data))
      getOperadoresRegraCredito().then( (data) => setOperadores(data))
      getAcoesRegraCredito().then( (data) => setAcoes(data))
      getResultadoMotorCredito().then((data) => {
        setResultados(data)
        setValue('resultadoMotorCredito', data.filter((s) => s.nome === motorCredito.labelResultadoMotorCredito)[0]);
        
      })
      const lazyClient = {
        first: 0,
        rows: 99999999,
        page: 1,
        cliente: 'null',
        documento: 'null',
        codigoClienteErp: null,
        inativo: null,
        idFranquia: state.user.franquiaSelected?.id ? state.user.franquiaSelected?.id : null,
        sortField: 'nome',
        sortOrder: SortOrder.DESC
      }
      const clientes : any[] = [];
      findClient(lazyClient).then(data => {
        data.clientes.forEach( (c: { nome: string; id: string; }) => {
          clientes.push({name: c.nome, code:c.id})
          if(motorCredito.id && motorCredito.idCliente && c.nome === motorCredito.nomeCliente){
            setSelectedClient({name:motorCredito.nomeCliente, code:c.id})
          }
          if(state.user.cliente && c.nome === state.user.cliente.nome){
            setSelectedClient({name:state.user.cliente.nome, code:c.id})
          }
        })
      })
      setClients(clientes);
    }, []) 
 
  return (
    <form onSubmit={handleSubmit(onSubmit)} className="flex flex-column gap-2">
        <div>
          <div className="grid">
              <div className="col p-fluid flex flex-wrap">
                
                  <Controller
                      name="descricao"
                      control={control}
                      rules={{ required: 'Descrição é Obrigatório' }}
                      render={({ field, fieldState }) => (
                          <>
                              <label htmlFor={field.name} className={classNames({ 'p-error': errors.descricao })}></label>
                              <span className="">
                              <div>
                                <label htmlFor="descricao" className="font-bold block mb-2 required">{t('descricao')} </label>
                                <InputText style={{width:'100%'}} id={field.name} value={field.value} className={classNames({ 'p-invalid': fieldState.error })} onChange={(e) => field.onChange(e.target.value)} />
                                </div>
                              </span>
                              {getFormErrorMessage(field.name)}
                          </>
                      )}
                  />
                    
               
              </div>
              <div className="col p-fluid flex flex-wrap">
                <Controller
                      name="resultadoMotorCredito"
                      control={control}
                      rules={{ required: 'Descrição é Obrigatório' }}
                      render={({ field, fieldState }) => (
                          <>
                              <label htmlFor={field.name} className={classNames({ 'p-error': errors.descricao })}></label>
                              <span className="">
                              <div>
                              <label htmlFor="resultado" className="font-bold block mb-2 required">{t('resultado')} </label>
                              <Dropdown style={{width: '50%'}} value={field.value}  onChange={(e) =>{field.onChange(e.value)}} options={resultados} optionLabel="nome" placeholder="Selecione Resultado" 
                                  filter className="w-full md:w-14rem" /> 
                                </div>
                              </span>
                              {getFormErrorMessage(field.name)}
                          </>
                      )}
                  />
                     
              </div>
              <div className="col">
                <div>
                  <label className="label-dados" style={{paddingLeft:'0'}}>{t('cliente')}</label>
                  <Dropdown disabled={state.user.cliente} style={{width: '50%'}} value={selectedClient} onChange={(e) => setSelectedClient(e.value)} options={clients} optionLabel="name" placeholder="Selecione Cliente" 
                          filter className="w-full md:w-14rem" />  
                </div>
              </div>
              
          </div>
          <br></br>
          <DataTable size="small" paginatorRight={paginatorRight} footer={paginatorRight} value={regras} tableStyle={{ minWidth: '50rem' }}>
            <Column field="descricao" header={t('regra')}></Column>
            <Column field="formula.descricao" header={t('formula')}></Column>
            <Column body={editRegraBodyTemplate} />
          </DataTable>
       
        </div>
        <br></br>
        <br></br>
        <div style={{display:"flex", justifyContent:"flex-end", paddingTop:"1rem"}} className=" flex">
            <Button style={{marginRight:"1rem", backgroundColor:'#183462'}} label="Salvar" type="submit"   />
            <Button icon="pi pi-times" onClick={onClose} rounded outlined severity="danger" aria-label="Cancel" />
        </div> 
    </form>
    
  )
}